import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, SectionTitle, InputGroup, InputWrapper, Label, Input } from '../AdvancedSearchBuilder.styled';
import { getCurrencySymbol } from '../../../../../lib/formatCurrency';

const PriceSection = ({ minPrice, maxPrice, onChange }) => {
  const { t } = useTranslation();
  const currencySymbol = getCurrencySymbol();
  return (
    <Section>
      <SectionTitle>{t('price')}</SectionTitle>
      <InputGroup>
        <InputWrapper>
          <Label>{t('priceFrom')} ({currencySymbol})</Label>
          <Input type="number" placeholder="0" value={minPrice} onChange={(e) => onChange('minPrice', e.target.value)} />
        </InputWrapper>
        <InputWrapper>
          <Label>{t('priceTo')} ({currencySymbol})</Label>
          <Input type="number" placeholder="999" value={maxPrice} onChange={(e) => onChange('maxPrice', e.target.value)} />
        </InputWrapper>
      </InputGroup>
    </Section>
  );
};

export default PriceSection;

